import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { ProofStrip } from '../components/home/ProofStrip';
import { MadeHere } from '../components/home/MadeHere';
import { SupplyList } from '../components/home/SupplyList';
import { QuoteSection } from '../components/home/QuoteSection';
import { MissionVision } from '../components/shared/MissionVision';
import { OrderSteps } from '../components/shared/OrderSteps';
import { FaqList } from '../components/shared/FaqList';
export function Home() {
  return <>
      <HomeHero data-id="element-335" data-mp="24htrulnneyj5" />
      <ProofStrip data-id="element-336" data-mp="24haeli8y0ybg" />
      <MadeHere data-id="element-337" data-mp="24iv9xa330lad" />
      <SupplyList data-id="element-338" data-mp="29gdeypdzagd3" />
      <MissionVision tone="coal" data-id="element-339" data-mp="29fvfljw0rm0y" />
      <OrderSteps data-id="element-340" data-mp="29etvyr0xtr7m" />
      <section className="bg-coal py-20 md:py-32" aria-labelledby="faq-heading" data-id="element-341" data-mp="29ihp3p2h0blt">
        <div className="mx-auto grid max-w-[1320px] gap-10 px-5 md:px-8 lg:grid-cols-12 lg:gap-12" data-id="element-342" data-mp="2dj1jikvnt149">
          <h2 id="faq-heading" className="text-center font-display text-5xl font-bold uppercase leading-[0.9] text-chalk md:text-7xl lg:col-span-4 lg:text-left" data-id="element-343" data-mp="3kxd2z8tam91b">
            Frequently Asked <span className="text-flame" data-id="element-344" data-mp="30ufaac5ro36p">Questions</span>
          </h2>
          <div className="lg:col-span-8" data-id="element-345" data-mp="2vy85wnt0qzqv">
            <FaqList data-id="element-346" data-mp="2qybx8b9dmk4z" />
          </div>
        </div>
      </section>
      <QuoteSection data-id="element-347" data-mp="2r0opbh8umavr" />
    </>;
}